/*global angular appGlobalSettings*/
import 'babel-polyfill';
import './css/module.css';
import {UniFramework, UniAfConfigLoader} from 'uni-framework';

import language from './js/language';
import config from './js/config.js';
import {toArray} from './js/util.js';
import uniPDFViewer from 'unicorplib-js/src/components/uniPDFViewer/entry';
import {uniWindow} from 'unicorplib-js/src/components/uniWindow/entry';
import AppMenuCtrl from './template/controller.appmenu';

let app = angular.module(appGlobalSettings['bower']['name'], ['ui.router', 'pascalprecht.translate', UniFramework, uniWindow, uniPDFViewer])
	.config(language)
	.config(config)
	.controller('AppMenuCtrl', AppMenuCtrl)
	.filter('to_array', toArray)
	.run(['$state', '$rootScope', '$uniLoading', function ($state, $rootScope, $uniLoading) {
		$rootScope.$on('$stateChangeStart', function (e: any, to: any) {
				if (to.name == 'app.login') {
					e.preventDefault();
					$state.go('app.main');
					$uniLoading.setProcess(0);
				}
			}
		)
	}]);

UniAfConfigLoader(app);
